import React from 'react';
import { PropTypes } from 'prop-types';
import { Row, Col, Grid } from 'react-material-responsive-grid';
import styles from 'shared/styles.css';
import materiaUIStyle from 'shared/materialUIFormat/miscFormatting';
import IndeterminateCircularProgress from 'shared/components/IndeterminateCircularProgress';
import CategoryCard from './CategoryCard';

const CategoriesDisplay = props => {
	if (props.isFetching) {
		return (
			<div>
				<IndeterminateCircularProgress size={60} />
			</div>
		);
	}

	if (props.categories.length === 0) {
		return <span />;
	}

	return (
		<div className={styles.categorySection}>
			<Grid marginless>
				<Row>
					{props.categories.map(category => (
						<Col
							xs4={4}
							xs8={4}
							sm12={4}
							md={3}
							xl={3}
							className={styles.cardCol}
							key={category.categoryId}
						>
							<div style={materiaUIStyle.setHeight100}>
								<CategoryCard
									id={category.categoryId}
									cat={category.name}
									description={category.description}
									pictureUrl={category.pictureUrl}
								/>
							</div>
						</Col>
					))}
				</Row>
			</Grid>
		</div>
	);
};

CategoriesDisplay.propTypes = {
	categories: PropTypes.arrayOf(
		PropTypes.shape({
			categoryId: PropTypes.number,
			name: PropTypes.string,
			description: PropTypes.string,
			pictureUrl: PropTypes.string,
		}),
	).isRequired,
	isFetching: PropTypes.bool.isRequired,
};

export default CategoriesDisplay;
